// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3K13Q","colMin":"styles_colMin__26TNN","colCheckbox":"styles_colCheckbox__2svIT"};